export const EASE_OUT = [0.4, 0, 0.2, 1] as const;
export const DURATION_SM = 0.2;
export const DURATION_MD = 0.35;
export const STAGGER_STEP = 0.06;
export const STAGGER_DELAY = 0.04;

export const fadeInUp = {
  hidden: { opacity: 0, y: 12 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATION_MD, ease: EASE_OUT },
  },
};

export const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: STAGGER_STEP, delayChildren: STAGGER_DELAY },
  },
};

export const cardHover = {
  y: -4,
  boxShadow: "0px 8px 24px -16px rgba(0,0,0,0.35)",
  transition: { duration: DURATION_SM, ease: EASE_OUT },
};
